module.exports = {
  RichText: {
    background_color: "Arka Plan Rengi",
    border_color: "Çerçeve Rengi",
    border_size: "Çerçeve Genişliği",
    border_style: "Çerçeve Stili",
    box_style: "Kutu Stili",
    opacity: "Opaklık",
    padding: "Alan",
    PluginName: "Zengin Metin",
    radius: "Radyan",
    source: "Kaynak",
  },
};
